import { createElement, ReactNode } from 'react';
import { PatternProps } from '../Pattern';

import GalleryTriptic from './GalleryTriptic';
import GalleryCarousel from './GalleryCarousel';
import GalleryBanner from './GalleryBanner';
import GalleryGrid from './GalleryGrid';
import { SxStyleProp } from '../Rebass/types';

const galleryVariants = {
  triptic: GalleryTriptic,
  carousel: GalleryCarousel,
  banner: GalleryBanner,
  grid: GalleryGrid,
};

interface GalleryItem {
  src?: string;
  alt?: string;
  desc?: string;
}

export interface GalleryProps {
  variant?: string;
  headline?: string;
  description?: React.ReactNode;
  itemsToShow?: number;
  items: Array<GalleryItem>;
  arrowPosition?: string;
  hasPagination?: boolean;
  lodge?: string;
  delay?: number;
  renderCta?: () => React.ReactNode;
  children?: ReactNode;
  bg?: string;
  ratio?: string;
  overflow?: string;
  showPattern?: boolean;
  patternProps?: PatternProps;
  headingStyles?: {
    headline: SxStyleProp;
    description: SxStyleProp;
  };
  initialIndex?: number;
  // Is this for the result lodge component
  resultLodge?: boolean;
  className?: string;
}

const Gallery = ({ variant, children, ...props }) =>
  createElement(galleryVariants[variant], { ...props, variant }, children);

export default Gallery;
